import { createBrowserRouter, type RouteObject } from "react-router";
import { Home } from "./routes/Home";
import { NotFound } from "./routes/NotFound";
import { Open } from "./routes/Open";
import { RootLayout } from "./routes/RootLayout";

export const routes: RouteObject[] = [
  {
    element: <RootLayout />,
    children: [
      { index: true, element: <Home /> },
      // App deep links: /open/<any/path> hands off to the `progress://` scheme.
      { path: "open/*", element: <Open /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
